"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantRevokeRightsService = void 0;
class GrantRevokeRightsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    postApiV1WorkspacesUsers({ workspaceId, kscUserId, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/workspaces/{workspaceId}/users/{kscUserId}',
            path: {
                workspaceId: workspaceId,
                kscUserId: kscUserId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                409: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.GrantRevokeRightsService = GrantRevokeRightsService;
